import { warn } from '@execonline-inc/logging';
import { useEffect, useState } from 'react';
import { State, error, loading, ready, waiting } from './Types';

export const useSizedImage = (uri: string) => {
  const [state, setState] = useState<State>(waiting());

  useEffect(() => {
    if (!uri) return;

    setState(loading(uri));
    const image = new Image();

    const handleLoad = () => {
      setState(ready({ width: image.width, height: image.height }));
    };

    const handleError = () => {
      setState(error(uri));
      warn(`Unable to preload image at "${uri}"`);
    };

    image.onload = handleLoad;
    image.onerror = handleError;
    image.src = uri;

    return () => {
      image.onload = null;
      image.onerror = null;
    };
  }, [uri]);

  return { state };
};
